import React from 'react'
import { SpinnerLoad } from './Loading/SpinnerLoad'

export const DashCard = ({name,number,load}:Props) => {
    return(
        <div className='bg-white border border-gray-500 rounded-md flex-col pt-2 px-4 pb-5'>
            <div className='font-semibold mb-3'>{name}</div>
            <div className='text-center font-bold text-5xl text-blue-500'>{!load ? number : <SpinnerLoad />  }</div>
        </div>
    )
}

interface Props {
    name:string,
    number:number,
    important?:boolean
    load?:boolean
}